
import './App.css';
import Journey from './mdq-pms/Journey';
import About from './mdq-pms/About';
import Features from './mdq-pms/Features';
import Home from './mdq-pms/Home';
import What from './mdq-pms/What';
import Application from './mdq-pms/Application';
import Details from './mdq-pms/Details';
import Results from './mdq-pms/Results';
import Sales from './mdq-pms/Sales';
import Founder from './mdq-pms/Founder';
import Contact from './mdq-pms/Contact';
import Thank from './mdq-pms/Thank';
import Navbar from './mdq-pms/Navbar';

function App() {
  return (
    
     <>
      <Navbar/>
      <Home/>
      <About/>
      <What/>
      <Features/>
      <Journey/>
      <Application/>
      <Details/>
      <Results/>
      <Sales/>
      <Founder/>
      <Contact/>
      <Thank/>
      
     
     
     </>
       
    
  );
}

export default App;
